<template><span style="display: none"><slot /></span></template>

<script>
function normalizePosition(position) {
  if (!position) return null
  const lat = typeof position.lat === 'function' ? position.lat() : position.lat
  const lng = typeof position.lng === 'function' ? position.lng() : position.lng
  const parsedLat = Number(lat)
  const parsedLng = Number(lng)
  return Number.isFinite(parsedLat) && Number.isFinite(parsedLng)
    ? [parsedLat, parsedLng]
    : null
}

export default {
  name: 'LeafletMarker',
  inject: ['leafletMapContext'],
  props: {
    position: { type: [Object, Array], default: null },
    draggable: { type: Boolean, default: false },
    clickable: { type: Boolean, default: true },
    icon: { type: [Object, String], default: null }
  },
  data: () => ({ marker: null, destroyed: false }),
  watch: {
    position: {
      deep: true,
      handler(value) {
        const position = normalizePosition(value)
        if (this.marker && position) this.marker.setLatLng(position)
      }
    },
    draggable(value) {
      if (!this.marker || !this.marker.dragging) return
      value ? this.marker.dragging.enable() : this.marker.dragging.disable()
    },
    icon: {
      deep: true,
      handler() {
        if (this.marker) this.marker.setIcon(this.buildIcon())
      }
    }
  },
  mounted() {
    this.leafletMapContext.whenReady(map => {
      if (this.destroyed) return
      const position = normalizePosition(this.position)
      if (!position) return

      this.marker = window.L.marker(position, {
        draggable: this.draggable,
        interactive: this.clickable,
        icon: this.buildIcon()
      }).addTo(map)

      this.marker.on('click', event => this.$emit('click', this.compatEvent(event)))
      this.marker.on('drag', event => this.$emit('drag', this.compatEvent(event)))
      this.marker.on('dragend', event => this.$emit('dragend', this.compatEvent(event)))
    })
  },
  beforeDestroy() {
    this.destroyed = true
    if (this.marker && this.leafletMapContext.map) {
      this.leafletMapContext.map.removeLayer(this.marker)
    }
    this.marker = null
  },
  methods: {
    buildIcon() {
      const url = typeof this.icon === 'string' ? this.icon : this.icon && this.icon.url
      if (!url) return new window.L.Icon.Default()

      const size = this.icon && this.icon.scaledSize
      const width = size && Number(size.width)
      const height = size && Number(size.height)
      const options = {
        iconUrl: url,
        iconSize: [36, 48],
        iconAnchor: [18, 48]
      }

      if (width && height) {
        options.iconSize = [width, height]
        options.iconAnchor = [width / 2, height]
      }

      return window.L.icon(options)
    },
    compatEvent(event) {
      const latLng = event.target.getLatLng()
      return {
        originalEvent: event,
        latLng: {
          lat: () => latLng.lat,
          lng: () => latLng.lng
        }
      }
    }
  }
}
</script>
